import { POSITION } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { api, config } from "../../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../../configs/config";
import { LENDER_ID, REPAYMENT_COLLECTION_TYPE } from "../../../configs/constants";
import { Platform, Linking, } from "react-native";
import SharedPropsService, { BUILD_TYPE, getBuildType } from "../../../SharedPropsService";
import { RAZOR_PAY_PREFERRED_METHOD, getRazorpayKey, handlePayment, handleWebPayment, isFromAndroidWebview, isIframe } from "../../../configs/utils";
import { ColorTokens, IconTokens, SizeTypeTokens, WIDGET } from "@voltmoney/schema";
import { InAppBrowser } from 'react-native-inappbrowser-reborn';
import BackgroundTimer from 'react-native-background-timer';
import { ACTION } from "./types";
//@ts-ignore
import ThemeProvider from "@voltmoney/theme";
import { getParameters } from "../../../configs/uri-config-utils";
const theme = ThemeProvider.getTheme();
const colorMapping = theme.colors;
let timer;
export const needHelp = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('CONTACT_US_BUTTON_CLICKED');
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBack = async (action, _datastore, { goBack, navigateWithClear }) => {
    const isFromDsp = action?.payload?.isFromDsp;
    if (isFromDsp) {
        await navigateWithClear(ROUTE.DASHBOARD, {});
    }
    else
        await goBack();
};
export const navigateToRecomendedScreen = async (action, _datastore, { goBack, navigate }) => {
    const shortfallDetails = action?.payload.shortfallDetails;
    await navigate(ROUTE.SHORTFALL_RECOMENDED_REPAY_SCREEN, { shortfallDetails });
};
export const navigateToTransaction = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.TRANSACTIONS);
};
export const leadToPaymentWeb = async (action, _datastore, { network, appendWidgets, openNewTab, removeWidgets, showPopup, setDatastore, goBack, navigate, getHeight, instrumentTrack, navigateToBase }) => {
    await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
        loading: true
    });
    const amount = action?.payload?.amountToPay;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    const user = await SharedPropsService.getUser();
    const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
    var popupWindow;
    let tataFlag = false;
    const test_numbers_bajaj_pg = await SharedPropsService.getFirebaseConfig()?.test_numbers_bajaj_pg;
    if (!test_numbers_bajaj_pg) {
        return false;
    }
    const test_numbers_bajaj_pg_object = JSON.parse(test_numbers_bajaj_pg);
    const bajajPgPhoneNumbers = test_numbers_bajaj_pg_object?.numbers;
    let showBajajPg = await SharedPropsService.getFirebaseConfig().show_bajaj_pg;
    // @ts-ignore
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = getParameters(url);
    const platformCode = params?.platform || '';
    let enableBajajPG = false;
    if (platformCode === undefined || platformCode === null || platformCode === '') {
        enableBajajPG = true;
    }
    else
        enableBajajPG = false;
    // @ts-ignore
    let isPaymentModeBajaj = enableBajajPG && (showBajajPg === true || showBajajPg === "true" || bajajPgPhoneNumbers.includes(user.user.phoneNumber)) && (userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId !== "Tata");
    let buildType = getBuildType();
    if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
        const accountId = userContextResponse?.data.linkedApplications[0].accountId;
        const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
        tataFlag = response?.data?.isEnabled;
    }
    if (lenderAccountId?.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
        const response = await network.post(`${api.collectionNew}`, {
            baseOriginUrl: `${config.APP_URL}`,
            paymentGatewayIntegrationType: 'PG_SDK',
            collectionAmount: `${amount}`,
            creditId: userCreditId,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
            collectionType: `${REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT}`
        }, { headers: await getAppHeader() });
        if (response?.status === 200) {
            const timeout = 600;
            const collectionId = response?.data?.collectionId;
            const currentOrderId = response?.data?.pgPaymentOrderId;
            const key = getRazorpayKey();
            const user = userContextResponse?.data;
            const color = colorMapping[ColorTokens.Primary_100];
            let preferredMethod = [''];
            const redirectingRoute = ROUTE.SHORTFALL_REPAY_SCREEN;
            if (amount <= 2000) {
                preferredMethod = RAZOR_PAY_PREFERRED_METHOD.LESS_THAN_2K;
            }
            else if (amount <= 100000) {
                preferredMethod = RAZOR_PAY_PREFERRED_METHOD.LESS_THAN_100K;
            }
            else {
                preferredMethod = RAZOR_PAY_PREFERRED_METHOD.DEFAULT;
            }
            await handleWebPayment(user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute);
        }
    }
    else
        await network.post(`${api.collectionNew}`, {
            baseOriginUrl: `${config.APP_URL}`,
            collectionAmount: `${amount}`,
            paymentGatewayType: isPaymentModeBajaj ? "BAJAJ" : null,
            creditId: userCreditId,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
            collectionType: `${REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT}`
        }, { headers: await getAppHeader() })
            .then(async (res) => {
            if (res.status === 200) {
                const isFromTata = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId === "Tata";
                if (Platform.OS !== 'web') {
                    if (isFromTata) {
                        BackgroundTimer.runBackgroundTimer(async () => {
                            console.log("REACHED IN THE METHOD");
                            //code that will be called every 3 seconds
                            network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                                if (response.data.collectionStatus !== 'REQUESTED') {
                                    BackgroundTimer.stopBackgroundTimer(); //after this call all code on background stop run.
                                    console.log("REACHED IN THE CALLBACK");
                                    instrumentTrack("CHROME_TAB_CLOSED", { collectionStatus: response.data.collectionStatus });
                                    InAppBrowser.close();
                                    removeWidgets(ROUTE.PAYMENT_START, [
                                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                        { id: "keyboardSpace", type: WIDGET.SPACE },
                                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    ]);
                                    navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                }
                            });
                        }, 3000);
                        // Only Android, iOS will ignore this call
                        instrumentTrack("CHROME_TAB_OPENED");
                        openLink(res?.data.paymentLink, setDatastore);
                    }
                    else {
                        appendWidgets(ROUTE.PAYMENT_START, {
                            repayLoanWebView: {
                                iframe: false,
                                uri: res.data.paymentLink,
                            },
                            keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        }, [
                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                            { id: "keyboardSpace", type: WIDGET.SPACE },
                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                        ], "customHeader");
                        removeWidgets(ROUTE.PAYMENT_START, [
                            {
                                id: "totalAmountShowStack",
                                type: WIDGET.CARD,
                                padding: {
                                    horizontal: 0,
                                    all: 0,
                                },
                                position: POSITION.ABSOLUTE_TOP,
                            },
                            {
                                id: "titleStack",
                                type: WIDGET.STACK,
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "fullAmountStackWithSpace",
                                type: WIDGET.STACK
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "divider",
                                type: WIDGET.DIVIDER
                            },
                            {
                                id: "partialAmountFullStack",
                                type: WIDGET.STACK
                            },
                            {
                                id: "proceedButtonStack",
                                type: WIDGET.STACK,
                                position: POSITION.ABSOLUTE_BOTTOM
                            },
                            {
                                id: "spaceLG",
                                type: WIDGET.SPACE
                            },
                            { id: "enterAmountFullStack", type: WIDGET.STACK },
                            { id: "amountMessage", type: WIDGET.TEXT }
                        ]);
                    }
                    setDatastore(action.routeId, "header", {
                        title: (isFromTata)
                            ? (tataFlag
                                ? "Paying to Tata Capital Limited"
                                : "Paying to Tata Capital Financial Services Ltd.")
                            : "Paying to Bajaj Finance"
                    });
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                            if (response.data.collectionStatus !== 'REQUESTED') {
                                clearInterval(timer);
                                if (result) {
                                    result?.close();
                                }
                                removeWidgets(ROUTE.PAYMENT_START, [
                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                ]);
                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
                else {
                    if ((isIframe() || isFromAndroidWebview()) && !isPaymentModeBajaj) {
                        showPopup({
                            isAutoTriggerCta: true,
                            type: 'DEFAULT',
                            iconName: IconTokens.Redirecting,
                            title: 'Waiting for response',
                            subTitle: 'Please wait while we process your request',
                            ctaAction: {
                                type: ACTION.BLANK_ACTION,
                                routeId: ROUTE.LOAN_AGREEMENT,
                                payload: {},
                            },
                            primary: false,
                        });
                        const url = res.data.paymentLink;
                        // Popup window size
                        const width = isFromTata ? 1002 : 504;
                        const height = 704;
                        // Calculate the position to center the popup on the screen
                        const left = (window.innerWidth - width) / 2;
                        const top = (window.innerHeight - height) / 2;
                        //openNewTab(url, OpenNewTabTargetType.popup, {
                        //     target: POPUP_TARGET_NAME.AGREEMENT,
                        //     width: APP_CONFIG.POP_UP_SIZE.WIDTH,
                        //     height: APP_CONFIG.POP_UP_SIZE.HEIGHT,
                        // })
                        // Open the popup window
                        if (isFromAndroidWebview()) {
                            popupWindow = window.open(url, "_blank");
                        }
                        else {
                            popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                        }
                    }
                    else {
                        if (lenderAccountId.toLowerCase() === "bajaj" && isPaymentModeBajaj) {
                            if (isIframe()) {
                                const form = document.createElement('form');
                                form.method = 'POST';
                                form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                    : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                form.target = 'paymentPopup'; // Add target for the popup window
                                // Create an input element
                                const input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = 'msg';
                                input.value = res.data.paymentLink;
                                popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                // Append input to form
                                form.appendChild(input);
                                document.body.appendChild(form);
                                form.submit();
                            }
                            else {
                                const form = document.createElement('form');
                                form.method = 'POST';
                                form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                    : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                form.target = 'paymentPopup'; // Add target for the popup window
                                // form.target = 'paymentPopup'; // Add target for the popup window
                                // Create an input element
                                const input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = 'msg';
                                input.value = res.data.paymentLink;
                                //  popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                // Append input to form
                                form.appendChild(input);
                                document.body.appendChild(form);
                                form.submit();
                            }
                            // Open a new popup window with the specified size
                        }
                        else {
                            const tataPaymentLink = res.data.paymentLink;
                            window.open(tataPaymentLink, "_self");
                            setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                                loading: false
                            });
                        }
                    }
                    if (isIframe() || isFromAndroidWebview()) {
                        const runPollar = async () => {
                            network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }, async () => {
                                return;
                            }, {
                                disableDefault: true
                            }).then((response) => {
                                if (popupWindow.closed) {
                                    goBack();
                                    clearInterval(timer);
                                }
                                else {
                                    if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                        removeWidgets(ROUTE.PAYMENT_START, [
                                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                            { id: "keyboardSpace", type: WIDGET.SPACE },
                                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                                        ]);
                                        clearInterval(timer);
                                        if (popupWindow) {
                                            popupWindow.close(); // Close the popup window if it exists
                                        }
                                        navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                    }
                                }
                            });
                        };
                        const timer = setInterval(() => {
                            runPollar();
                        }, APP_CONFIG.POLLING_INTERVAL);
                    }
                }
            }
            else {
                setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                    loading: false
                });
            }
        });
    if (Platform.OS !== "ios") {
        isIframeRemoved = true;
    }
};
let isIframeRemoved = false;
let result;
const openLink = async (url, setDatastore) => {
    try {
        if (await InAppBrowser.isAvailable()) {
            let result = await InAppBrowser.open(url, {
                // iOS Properties
                dismissButtonStyle: 'cancel',
                preferredBarTintColor: '#453AA4',
                preferredControlTintColor: 'white',
                readerMode: false,
                animated: true,
                modalPresentationStyle: 'fullScreen',
                modalTransitionStyle: 'coverVertical',
                modalEnabled: true,
                enableBarCollapsing: false,
                // Android Properties
                showInRecents: true,
                showTitle: true,
                toolbarColor: '#1434CB',
                secondaryToolbarColor: 'black',
                navigationBarColor: 'black',
                navigationBarDividerColor: 'white',
                enableUrlBarHiding: true,
                enableDefaultShare: true,
                forceCloseOnRedirection: false,
                // Specify full animation resource identifier(package:anim/name)
                // or only resource name(in case of animation bundled with app).
                animations: {
                    startEnter: 'slide_in_right',
                    startExit: 'slide_out_left',
                    endEnter: 'slide_in_left',
                    endExit: 'slide_out_right'
                },
                headers: {
                    'my-custom-header': 'my custom header value'
                }
            });
            if (result.type === "cancel") {
                // await setDatastore(ROUTE.INTEREST_REPAYMENT_DETAILS, "interestRepaymentDetails", <IntrestRepaymentCardProps>{
                //     showButtonLoading : false
                // })
                BackgroundTimer.stopBackgroundTimer();
            }
        }
        else
            Linking.openURL(url);
    }
    catch (error) {
    }
};
export const resetPage = async (action, _datastore, { network, setDatastore, navigateWithClear, removeWidgets, appendWidgets }) => {
    await removeWidgets(ROUTE.SHORTFALL_REPAY_SCREEN, [
        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
        { id: "keyboardSpace", type: WIDGET.SPACE },
        { id: "keyboardSpace2", type: WIDGET.SPACE },
        { id: "keyboardSpace3", type: WIDGET.SPACE },
    ]);
    clearInterval(timer);
    await navigateWithClear(ROUTE.DASHBOARD);
};
export const leadToPayment = async (action, _datastore, { network, appendWidgets, openNewTab, removeWidgets, showPopup, setDatastore, goBack, navigate, navigateToBase }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const amount = action?.payload?.amountToPay;
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    let popupWindow;
    const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
    let tataFlag = false;
    if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
        const accountId = userContextResponse?.data.linkedApplications[0].accountId;
        const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
        tataFlag = response?.data?.isEnabled;
    }
    //   await setDatastore(ROUTE.INTEREST_REPAYMENT_DETAILS, "interestRepaymentDetails", <IntrestRepaymentCardProps>{
    //     showButtonLoading : true
    // })
    if (lenderAccountId?.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
        const response = await network.post(`${api.collectionNew}`, {
            baseOriginUrl: `${config.APP_URL}`,
            paymentGatewayIntegrationType: 'PG_SDK',
            collectionAmount: `${amount}`,
            creditId: userCreditId,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
            collectionType: `${REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT}`
        }, { headers: await getAppHeader() });
        if (response?.status === 200) {
            const timeout = 600;
            const collectionId = response?.data?.collectionId;
            const currentOrderId = response?.data?.pgPaymentOrderId;
            const key = getRazorpayKey();
            const user = userContextResponse?.data;
            const color = colorMapping[ColorTokens.Primary_100];
            const preferredMethod = [''];
            const redirectingRoute = ROUTE.SHORTFALL_REPAY_SCREEN;
            if (amount <= 2000) {
                preferredMethod.push('upi', 'card');
            }
            else if (amount <= 50000) {
                preferredMethod.push('upi', 'card', 'netbanking');
            }
            else if (amount <= 100000) {
                preferredMethod.push('upi', 'netbanking');
            }
            else {
                preferredMethod.push('netbanking');
            }
            await handlePayment(user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute);
        }
    }
    else {
        let showBajajPg = await SharedPropsService.getFirebaseConfig().show_bajaj_pg;
        // @ts-ignore
        let isPaymentModeBajaj = (showBajajPg === true || showBajajPg === "true") && userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId !== "Tata";
        await network.post(`${api.collectionNew}`, {
            collectionAmount: `${amount}`,
            baseOriginUrl: Platform.OS === 'web' ? `${config.APP_URL}` : 'https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false',
            creditId: userCreditId,
            paymentGatewayType: isPaymentModeBajaj ? "BAJAJ" : null,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
            collectionType: `${REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT}`
        }, { headers: await getAppHeader() })
            .then(res => {
            if (res.status === 200) {
                const isFromTata = userContextResponse.data.linkedCredits[0].lendingPartnerId = "Tata";
                if (Platform.OS !== 'web' && !isFromTata) {
                    appendWidgets(ROUTE.OUTSTANDING_DUES, {
                        repayLoanWebView: {
                            iframe: false,
                            uri: res.data.paymentLink
                        },
                        keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                        keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                        keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        spaceXXL: { size: SizeTypeTokens.XXL }
                    }, [
                        { id: "spaceXXL", type: WIDGET.SPACE },
                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                        { id: "keyboardSpace", type: WIDGET.SPACE },
                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                    ], "manageLimit");
                    removeWidgets(ROUTE.OUTSTANDING_DUES, [
                        {
                            id: "manageLimit",
                            type: WIDGET.OUTSTANDING_DUES,
                        }
                    ]);
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "OUTSTANDING_DUES" }).then((response) => {
                            if (response.data.collectionStatus !== 'REQUESTED') {
                                clearInterval(timer);
                                removeWidgets(ROUTE.OUTSTANDING_DUES, [
                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    { id: "spaceXXL", type: WIDGET.SPACE }
                                ]);
                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
                else {
                    if ((isIframe() || isFromAndroidWebview()) && Platform.OS === 'web') {
                        showPopup({
                            isAutoTriggerCta: true,
                            type: 'DEFAULT',
                            iconName: IconTokens.Redirecting,
                            title: 'Waiting for response',
                            subTitle: 'Please wait while we process your request',
                            primary: false,
                        });
                        const url = res.data.paymentLink;
                        // Popup window size
                        const width = isFromTata ? 1002 : 504;
                        const height = 704;
                        // Calculate the position to center the popup on the screen
                        const left = (window.innerWidth - width) / 2;
                        const top = (window.innerHeight - height) / 2;
                        if (isFromAndroidWebview()) {
                            popupWindow = window.open(url, "_blank");
                        }
                        else {
                            popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                        }
                    }
                    else {
                        if (isFromTata) {
                            const tataPaymentLink = res.data.paymentLink;
                            BackgroundTimer.runBackgroundTimer(async () => {
                                //code that will be called every 3 seconds
                                network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                                    if (response.data.collectionStatus !== 'REQUESTED') {
                                        //after this call all code on background stop run.
                                        if (Platform.OS !== 'ios') {
                                            BackgroundTimer.stopBackgroundTimer();
                                        }
                                        InAppBrowser.close();
                                        if (Platform.OS === 'ios') {
                                            navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId, stopInterval: BackgroundTimer.stopBackgroundTimer() });
                                        }
                                        else {
                                            navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                        }
                                    }
                                });
                            }, 3000);
                            // Only Android, iOS will ignore this call
                            if (isPaymentModeBajaj) {
                                appendWidgets(ROUTE.SHORTFALL_REPAY_SCREEN, {
                                    repayLoanWebView: {
                                        iframe: Platform.OS === 'web',
                                        uri: res.data.paymentLink,
                                        doFormPost: true,
                                        billDeskCancelAction: {
                                            type: ACTION.CANCEL_ACTION,
                                            routeId: ROUTE.SHORTFALL_REPAY_SCREEN
                                        }
                                    },
                                    keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                                    keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                                    keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                                }, [
                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW, padding: { horizontal: 16, vertical: 16 } },
                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                ], "shortfallRepay");
                                removeWidgets(ROUTE.SHORTFALL_REPAY_SCREEN, [
                                    {
                                        id: "shortfallRepay",
                                        type: WIDGET.SHORTFALL_REPAY,
                                    },
                                    {
                                        id: "spaceLG",
                                        type: WIDGET.SPACE
                                    },
                                    {
                                        id: "titleStack",
                                        type: WIDGET.STACK,
                                    },
                                    {
                                        id: "spaceXXXL",
                                        type: WIDGET.SPACE
                                    },
                                    {
                                        id: "selectFullAmountStack",
                                        type: WIDGET.STACK
                                    },
                                    {
                                        id: "spaceXXXL",
                                        type: WIDGET.SPACE
                                    },
                                    {
                                        id: "divider",
                                        type: WIDGET.DIVIDER
                                    },
                                    {
                                        id: "partialAmountFullStack",
                                        type: WIDGET.STACK
                                    },
                                    {
                                        id: "proceedButtonStack",
                                        type: WIDGET.STACK,
                                        position: POSITION.ABSOLUTE_BOTTOM
                                    },
                                    {
                                        id: "spaceLG",
                                        type: WIDGET.SPACE
                                    },
                                    { id: "enterAmountFullStack", type: WIDGET.STACK },
                                    { id: "amountMessage", type: WIDGET.TEXT }
                                ]);
                            }
                            else {
                                openLink(res?.data.paymentLink, setDatastore);
                            }
                        }
                        else {
                            appendWidgets(ROUTE.SHORTFALL_REPAY_SCREEN, {
                                repayLoanWebView: {
                                    iframe: Platform.OS === 'web',
                                    uri: res.data.paymentLink
                                },
                                keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                                keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                                keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                            }, [
                                { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                { id: "keyboardSpace", type: WIDGET.SPACE },
                                { id: "keyboardSpace2", type: WIDGET.SPACE },
                                { id: "keyboardSpace3", type: WIDGET.SPACE },
                            ], "header");
                            removeWidgets(ROUTE.SHORTFALL_REPAY_SCREEN, [
                                {
                                    id: "totalAmountShowStack",
                                    type: WIDGET.CARD,
                                    padding: {
                                        horizontal: 0,
                                        all: 0,
                                    },
                                    position: POSITION.ABSOLUTE_TOP,
                                },
                                {
                                    id: "spaceLG",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "titleStack",
                                    type: WIDGET.STACK,
                                },
                                {
                                    id: "spaceXXXL",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "selectFullAmountStack",
                                    type: WIDGET.STACK
                                },
                                {
                                    id: "spaceXXXL",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "divider",
                                    type: WIDGET.DIVIDER
                                },
                                {
                                    id: "partialAmountFullStack",
                                    type: WIDGET.STACK
                                },
                                {
                                    id: "proceedButtonStack",
                                    type: WIDGET.STACK,
                                    position: POSITION.ABSOLUTE_BOTTOM
                                },
                                {
                                    id: "spaceLG",
                                    type: WIDGET.SPACE
                                },
                                { id: "enterAmountFullStack", type: WIDGET.STACK },
                                { id: "amountMessage", type: WIDGET.TEXT }
                            ]);
                            setDatastore(action.routeId, "customHeader", {
                                title: (isFromTata)
                                    ? (tataFlag
                                        ? "Paying to Tata Capital Limited"
                                        : "Paying to Tata Capital Financial Services Ltd.")
                                    : "Paying to Bajaj Finance"
                            });
                        }
                    }
                    if (isIframe()) {
                        const runPollar = async () => {
                            network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "SHORTFALL_REPAY_SCREEN" }, async () => {
                                return;
                            }, {
                                disableDefault: true
                            }).then((response) => {
                                if (popupWindow.closed) {
                                    goBack();
                                    clearInterval(timer);
                                }
                                else {
                                    if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                        removeWidgets(ROUTE.PAYMENT_START, [
                                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                            { id: "keyboardSpace", type: WIDGET.SPACE },
                                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                                        ]);
                                        clearInterval(timer);
                                        if (popupWindow) {
                                            popupWindow.close(); // Close the popup window if it exists
                                        }
                                        navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                    }
                                }
                            });
                        };
                        timer = setInterval(() => {
                            runPollar();
                        }, APP_CONFIG.POLLING_INTERVAL);
                    }
                }
            }
        });
    }
};
export const leadToPaymentPage = async (action, _datastore, { navigate }) => {
    const selectedAmount = action?.payload?.amountToPay;
    const collectionType = REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT;
    await navigate(ROUTE.CONFIRM_AND_PAYMENT, { selectedAmount, collectionType });
};
